import { Injectable } from '@angular/core';
import { FetchResult, gql } from '@apollo/client/core';
import { Curriculo } from '@app/models/curriculo/curriculo.model';
import { Apollo } from 'apollo-angular';
import { Observable } from 'rxjs';
import { S3Client, PutObjectCommand } from '@aws-sdk/client-s3';
import { environment } from 'environments/environment';

@Injectable()
export class TrabalheConoscoService {
  constructor(private _apollo: Apollo) {}

  public saveCurriculo(curriculo: Curriculo): Observable<FetchResult<any>> {
    const mutation = gql`
      mutation saveCurriculoMutation($input: CreateCurriculoInputType!) {
        curriculo(input: $input) {
          id
        }
      }
    `;

    return this._apollo.mutate<any>({
      mutation,
      variables: { input: curriculo },
    });
  }

  public async uploadFile(file: File, contatoCandidato: string): Promise<string> {
    const extensao = file.type.substring(12, file.type.length);

    const s3 = new S3Client({
      credentials: {
        accessKeyId: environment.AWS.accessKeyId,
        secretAccessKey: environment.AWS.secretAccessKey,
      },
    });

    await s3.send(
      new PutObjectCommand({
        ACL: 'public-read',
        Bucket: environment.AWS.bucketName,
        Key: `curriculos/${contatoCandidato}.${extensao}`,
        ContentType: file.type,
        Body: file,
      })
    );

    const linkCurriculo = environment.AWS.url + `curriculos/${contatoCandidato}.${extensao}`;

    return linkCurriculo;
  }
}

export interface SaveCurriculoMutationResponse {
  curriculo: Curriculo;
  loading: boolean;
}
